import * as React from "react";
const SvgFiRrCloudShowersHeavy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-showers-heavy_svg__a)">
      <path
        fill="#062147"
        d="M14 24a1 1 0 0 1-.919-1.394l3-7a1 1 0 1 1 1.838.788l-3 7A1 1 0 0 1 14 24m-4 0a1 1 0 0 1-.919-1.394l3-7a1 1 0 0 1 1.838.788l-3 7A1 1 0 0 1 10 24m-4 0a1 1 0 0 1-.919-1.394l3-7a1 1 0 0 1 1.838.788l-3 7A1 1 0 0 1 6 24m-2-4.256a1 1 0 0 1-.333-.057A5.54 5.54 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.889A7.945 7.945 0 0 1 8.5.138a8.05 8.05 0 0 1 8.734 4.438 1.04 1.04 0 0 0 .743.57c6.526 1.219 8.22 10.177 2.565 13.673a1.001 1.001 0 1 1-1.078-1.684c4.144-2.515 2.884-9.179-1.878-10.029a3 3 0 0 1-2.158-1.672A6 6 0 0 0 4.11 9.147a3 3 0 0 1-.964 2.763 3.526 3.526 0 0 0 1.187 5.89A1 1 0 0 1 4 19.744"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-showers-heavy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudShowersHeavy;
